export default __webpack_public_path__ + "static/media/gardenqrbg.eca6ec48.png";